//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import React, { useContext, useEffect, useState } from "react";
import { Context } from "../common/context/Context";
import { Helmet } from "react-helmet-async";
import { Col, Container, Row, Card } from "react-bootstrap";
import { AdminDashboardActions } from "./adminDashboardActions";
import { Link } from 'react-router-dom';
import ErrorAlertMessage from "../common/alertMessages/errorAlertMessage";

const Admin = () => {
    const context = useContext(Context);
    //const [adminDashboardJson, setAdminDashboardJson] = useState({});
    const [adminDashboardCMS, setAdminDashboardCMS] = useState({
        title: "",
        description: "",
        tabNavigationTitle: "",
        pageContent: {},
    });
    const [adminDashboardData, setAdminDashboardData] = useState({
        clientData: [],
        usersData: [],
        candidateData: []
    });
    const [ctaLinks, setCTALinks] = useState([]);
    const [errorAlert, setErrorAlert] = useState({
        showAlert: false
    })
    let firstNameText = adminDashboardCMS && adminDashboardCMS.description;
    firstNameText = firstNameText.replace('*first name*', context.userDetails && context.userDetails?.firstName)

    const showErrorModal = () => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        refErrorMessageAlert.showAlert = false;
        setErrorAlert(refErrorMessageAlert)
    }

    const fetchAdminDashBoardData = async () => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        let refData = JSON.parse(JSON.stringify(adminDashboardData))

        await AdminDashboardActions.GetAdminDashboardData().then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    let resData = res.data && res.data;
                    let usersList = resData && resData.filter((x) => x.type == "Users");
                    let candidateList = resData && resData.filter((x) => x.type == "Candidate")
                    let clientsList = resData && resData.filter((x) => x.type == "Clients")
                    refData.clientData = sortByNewest(clientsList);
                    refData.candidateData = sortByNewest(candidateList);
                    refData.usersData = sortByNewest(usersList);
                    setAdminDashboardData(refData);
                }
                else {
                    refErrorMessageAlert.showAlert = true;
                    setErrorAlert(refErrorMessageAlert);
                    window.scrollTo(0, 0);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }

    const sortByNewest = (data) => {
        data.sort(function (a, b) {
            return new Date(b.triggeredTimeStamp) - new Date(a.triggeredTimeStamp);
        });
        return data.slice(0, 3);
    }

    const fetchAdminDashboardCMS = async () => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        let refDashBoardData = JSON.parse(JSON.stringify(adminDashboardCMS));
        const payload = { pagename: 'Dashboard' };
        await AdminDashboardActions.getAdminDashboardCMSContent(payload).then((res) => {
            if (res.status == 200 || res.status == 204) {
                const data = res.data;
                data.Pages.map((x) => {
                    if (x.Key === "AdminDashboard.AdminDashboardHeader") {
                        refDashBoardData.pageContent = x.Components;
                        refDashBoardData.tabNavigationTitle = x.TabNavigationTitle;
                        refDashBoardData.description = x.Description;
                        refDashBoardData.title = x.Title;
                        setAdminDashboardCMS(refDashBoardData);
                    }
                });
            }
            else {
                refErrorMessageAlert.showAlert = true;
                setErrorAlert(refErrorMessageAlert);
                window.scrollTo(0, 0);
            }
        });
    }

    const fetchAdminDashBoardTitleLabel = (key) => {
        if (adminDashboardCMS && adminDashboardCMS.pageContent["AdminDashboard.AdminDashboardTitle"]) {
            const adminDashBoardTitleLabel = adminDashboardCMS.pageContent["AdminDashboard.AdminDashboardTitle"];
            return returnLabel(adminDashBoardTitleLabel?.Labels, key)
        }
        return '';
    }

    const returnLabel = (labelArray = [], key) => {
        return labelArray.find((x) => x.Key === key)?.Phrase || '';
    }

    //commented due to sitecore integration
    // const fetchAdminDashboardJson = async () => {
    //     let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
    //     await AdminDashboardActions.GetAdminDashboardJSON().then(
    //         (res) => {
    //             if (res.status === 200 || res.status === 204) {
    //                 setAdminDashboardJson(JSON.parse(JSON.stringify(res?.data)));
    //             }
    //             else {
    //                 refErrorMessageAlert.showAlert = true;
    //                 setErrorAlert(refErrorMessageAlert);
    //                 window.scrollTo(0, 0);
    //             }
    //         },
    //         (err) => {
    //             console.log(err);
    //         }
    //     );
    // }
    // const fetchAdminDashboardLabel = (key) => {
    //     let refJsonContent = JSON.parse(JSON.stringify(adminDashboardJson));
    //     let label = "";

    //     refJsonContent?.Properties?.Labels?.map((x) => {
    //         if (x.Key === key) {
    //             label = x.Phrase;
    //         }
    //     });

    //     return label;
    // };

    const fetchAdminCTALinks = async (countryCode) => {

        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        await AdminDashboardActions.GetAdminCTALinks(countryCode).then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    setCTALinks(res?.data);
                }
                else {
                    refErrorMessageAlert.showAlert = true;
                    setErrorAlert(refErrorMessageAlert);
                    window.scrollTo(0, 0);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }

    const fetchUserDetails = async () => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        await AdminDashboardActions.GetUserDetails().then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    let resData = res?.data;
                    context.setUserDetails(resData)
                    fetchAdminCTALinks(resData?.countryCode)
                }
                // else {
                //     refErrorMessageAlert.showAlert = true;
                //     setErrorAlert(refErrorMessageAlert);
                //     window.scrollTo(0, 0);
                // }
            },
            (err) => {
                console.log(err);
            }
        );
    }

    const fetchUserAccount = async () => {

        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        await AdminDashboardActions.GetUserAccount().then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    let resData = res?.data;
                    context.setUserAccountData(resData)
                }
                // else {
                //     refErrorMessageAlert.showAlert = true;
                //     setErrorAlert(refErrorMessageAlert);
                //     window.scrollTo(0, 0);
                // }
            },
            (err) => {
                console.log(err);
            }
        )
    }

    useEffect(() => {
        fetchAdminDashboardCMS();
        if (window.sessionStorage.getItem('AccessToken') !== null) {
            fetchAdminDashBoardData()
            fetchUserDetails()
            fetchUserAccount()
        }
    }, []);

    const splitId = (id, idType) => {
        let splitId = id && id.split(",")
        let clientId = splitId && splitId[0];
        let personaId = splitId && splitId[2];
        let countryCode = splitId && splitId[1];

        if (idType === "clientId") {
            return clientId;
        } else if (idType === "countryCode") {
            return countryCode
        } else if (idType === "personaId") {
            return personaId;
        }
    }



    return (
        <React.Fragment>
            <Helmet title="Cards" />
            <Container fluid className="p-0">
                {errorAlert?.showAlert &&
                    <ErrorAlertMessage alertMessage="AllPages.ErrorAlertMessage" showAlert={showErrorModal} />
                }
                {context?.adminUser && context?.isUserActive ?
                    ((context.permissionsList && context.permissionsList.includes("Dashboard.All")) &&
                        <Row>
                            <Col xs="12">
                                <div>
                                    <h3 style={{ marginBottom: "1.5rem" }}> {context.userDetails?.firstName && firstNameText}</h3>
                                    <Card mt-3>
                                        <Card.Header>
                                            <Card.Title className="mb-0 m-4">{adminDashboardCMS?.pageContent["AdminDashboard.AdminDashboardTitle"]?.Title}</Card.Title>
                                        </Card.Header>
                                        <Card.Body className="row text-left pt-0 col">
                                            <Col lg='4' xs='12' className="m-0">
                                                <Card.Header>
                                                    <Card.Title className="mb-0 col-sm">{fetchAdminDashBoardTitleLabel('AdminDashboard.LastThreeClient')}</Card.Title>
                                                </Card.Header>
                                                <Card.Body>
                                                    {adminDashboardData && adminDashboardData?.clientData.map((x) => (
                                                        <ul>
                                                            <li>
                                                                <Link to={'/clients-profile'} state={{ clientId: splitId(x.sourceId, "clientId"), countryCode: splitId(x.sourceId, "countryCode"), personaId: splitId(x.sourceId, "personaId"), clientName: x.value }}>{x.value}</Link>
                                                            </li>
                                                        </ul>
                                                    ))}
                                                </Card.Body>
                                            </Col>
                                            <Col lg='4' xs='12' className="m-0">
                                                <Card.Header>
                                                    <Card.Title className="mb-0 col-sm">{fetchAdminDashBoardTitleLabel('AdminDashboard.Candidate')}</Card.Title>
                                                </Card.Header>
                                                <Card.Body>
                                                    {adminDashboardData && adminDashboardData?.candidateData.map((x) => {

                                                        let id = x.sourceId && x.sourceId.split(",");
                                                        let sourceId = id[0];
                                                        let refCode = id[1];

                                                        let nameString = x?.value?.split(" ");
                                                        let firstName = nameString && nameString[0] && nameString[0];
                                                        let lastName = nameString && nameString[1] && nameString[1];

                                                        return (
                                                            <ul>
                                                                <li>
                                                                    <Link to={'/candidateProfile'} state={{ candidateId: sourceId, referenceCode: refCode, candidateFName: firstName, candidateLName: lastName }}>{x.value}</Link>
                                                                </li>
                                                            </ul>
                                                        )
                                                    })}
                                                </Card.Body>
                                            </Col>
                                            <Col lg='4' xs='12' className="m-0">
                                                <Card.Header>
                                                    <Card.Title className="mb-0 col-sm">{fetchAdminDashBoardTitleLabel('AdminDashboard.UserThatAdminAccessed')}</Card.Title>
                                                </Card.Header>
                                                <Card.Body>
                                                    {adminDashboardData && adminDashboardData?.usersData.map((x) => (
                                                        <ul>
                                                            <li>
                                                                {x.value}
                                                            </li>
                                                        </ul>
                                                    ))}
                                                </Card.Body>
                                            </Col>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </Col>
                            <Col xs="12">
                                <Card>
                                    <Card.Body>
                                        <ul>
                                            {ctaLinks && ctaLinks.map((x) => (
                                                <li className="mb-1">
                                                    <Card.Link href={x.ctAurl} target="_blank"> {x.ctaTitle}</Card.Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    )
                    :
                    (<Row>
                        <Col>
                            <Card>
                                <Card.Body>{fetchAdminDashBoardTitleLabel('AdminDashboard.UserAccessErrorMessage')}</Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    )
                }
            </Container>
        </React.Fragment>
    );
}
export default Admin;
